exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-a36d22e2]{padding:0 50px}form .login_logo[data-v-a36d22e2]{padding-bottom:30px}form .login_logo span[data-v-a36d22e2]{font-size:31px;display:inline-block;line-height:30px;color:#9a9a9a}form .login_logo img[data-v-a36d22e2],form .login_logo span[data-v-a36d22e2]{height:30px;vertical-align:middle}form .sup[data-v-a36d22e2]{padding-bottom:20px}form .sup span[data-v-a36d22e2]{color:#5097ed;line-height:41px;cursor:pointer}.btns[data-v-a36d22e2]{padding-bottom:30px;margin-top:-40px}", ""]);

// exports
